mama-contact {
  display: block;

  .show-more {
    cursor: pointer;
  }
}
